import React from "react";
import { LogOut, ShieldAlert } from "lucide-react";
import { controllerImpersonation } from "../../services/controllers/impersonation";
import { useImpersonation } from "../../store/impersonation/useImpersonation";
import { getEntityName } from "./helpers";

export function ImpersonationBanner() {
  const bannerRef = React.useRef(null);
  const CLImpersonation = controllerImpersonation();
  const session = useImpersonation((st) => st.data.session);
  const syncSession = useImpersonation((st) => st.actions.syncSession);

  React.useEffect(() => {
    syncSession();
    window.addEventListener("storage", syncSession);

    return () => window.removeEventListener("storage", syncSession);
  }, [syncSession]);

  React.useLayoutEffect(() => {
    if (!session?.active) {
      document.documentElement.style.setProperty("--impersonation-banner-height", "0px");
      return;
    }

    const updateBannerHeight = () => {
      const height = bannerRef.current?.offsetHeight || 0;
      document.documentElement.style.setProperty("--impersonation-banner-height", `${height}px`);
    };

    updateBannerHeight();

    const resizeObserver = new ResizeObserver(updateBannerHeight);
    if (bannerRef.current) resizeObserver.observe(bannerRef.current);

    window.addEventListener("resize", updateBannerHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateBannerHeight);
      document.documentElement.style.setProperty("--impersonation-banner-height", "0px");
    };
  }, [session?.active]);

  if (!session?.active) return null;

  const targetUser = session.impersonation?.targetUser;
  const store = session.impersonation?.store;
  const targetName = session.impersonation?.targetName || getEntityName(targetUser);
  const storeName = session.impersonation?.storeName || getEntityName(store);

  return (
    <div ref={bannerRef} className="z-[90] flex min-h-12 w-full flex-col items-start justify-between gap-3 border-y border-amber-300 bg-amber-100 px-4 py-2 text-amber-950 shadow-md md:flex-row md:items-center">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <ShieldAlert className="h-5 w-5" />
        <span>Você está acessando como {targetName} na loja {storeName}.</span>
      </div>
      <button
        type="button"
        onClick={CLImpersonation.stop}
        className="inline-flex items-center gap-2 rounded bg-amber-900 px-3 py-2 text-sm font-semibold text-white transition hover:bg-amber-950"
      >
        <LogOut className="h-4 w-4" />
        Voltar para minha conta
      </button>
    </div>
  );
}
